"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sharedURLs = exports.url = void 0;

var _environment = require("./environment");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* --------------- UTILITIES : URLs --------------- */
// set urls based on dynamic environment variable
// AWS URLs
// CloudFront Distribution


var embedDistribution;
var headerCodeDistribution; // Static Assets

var staticAPI; // Insticator URLs

var baseURL;
var siteURL; // Insticator Projects
// CA - Application

var caAPI; // CMS - Content Management System

var cmsAPI; // Embed AKA Admin Panel AKA Old Dashboard

var embedAPI; // ASU - Article Sentiments Application

var asuAPI; // PPA - Publisher Portal Application

var ppaAPI; // RMS - Revenue Management System

var rmsAPI; //SPM - Publisher and SSP Management

var spmAPI; //MOCK - Mock Up Generator Backend

var mockupAPI; // Commenting Platform

var commenting; // Core Commenting Unit

var ccuAPI; // Rating Uniit

var ratingAPI; // Admin Panel

var newAdminPanel; // populate variables with urls based on environment

switch (_environment.environment) {
  case 'PRODUCTION':
    staticAPI = 'https://static.instiengage.com';
    embedDistribution = 'https://dzh3i6aoot1g7.cloudfront.net';
    headerCodeDistribution = 'd3lcz8vpax4lo2.cloudfront.net';
    siteURL = 'insticator';
    baseURL = 'insticator.com';
    caAPI = 'https://ca.insticator.com';
    cmsAPI = 'https://cms.insticator.com';
    commenting = 'https://soapps.net/live';
    ccuAPI = 'https://ccu.insticator.com';
    ratingAPI = 'https://rating.insticator.com';
    embedAPI = 'https://dashboard.insticator.com';
    ppaAPI = 'https://ppa.insticator.com';
    asuAPI = 'https://asu.insticator.com';
    rmsAPI = 'https://rms.insticator.com';
    spmAPI = 'https://spm.insticator.com';
    mockupAPI = 'https://mockup.insticator.com';
    newAdminPanel = 'http://admin.insticator.com';
    break;

  case 'LOCALHOST':
    staticAPI = 'https://d1i85t02k7w8m1.cloudfront.net';
    embedDistribution = 'https://d2jxnpxaf6d8ub.cloudfront.net';
    headerCodeDistribution = 'd1mxva141a8fyb.cloudfront.net';
    siteURL = 'hunchme';
    baseURL = 'localhost';
    caAPI = 'http://localhost:5555';
    cmsAPI = 'http://localhost:9000';
    commenting = 'https://soapps.net/dev';
    ccuAPI = 'http://localhost:7700';
    ratingAPI = 'http://localhost:7700';
    embedAPI = 'http://dashboard.localhost:5002';
    ppaAPI = 'http://localhost:5000';
    asuAPI = 'http://localhost:3020';
    rmsAPI = 'http://localhost:7788';
    spmAPI = 'http://localhost:9090';
    mockupAPI = 'http://localhost:6789';
    newAdminPanel = 'http://localhost:3010';
    break;

  case 'DEV':
    staticAPI = 'https://d1i85t02k7w8m1.cloudfront.net';
    embedDistribution = 'https://dchetohgcb1b1.cloudfront.net';
    headerCodeDistribution = 'd2uyq6p4qku0nd.cloudfront.net';
    siteURL = 'insticator';
    baseURL = 'insticator.devenv';
    caAPI = 'https://ca.insticator.devenv';
    cmsAPI = 'https://cms.insticator.devenv';
    commenting = 'https://staging.soapps.net/test';
    ccuAPI = 'https://ccu.insticator.devenv';
    ratingAPI = 'https://rating.insticator.devenv';
    embedAPI = 'https://dashboard.insticator.devenv';
    ppaAPI = 'https://ppa.insticator.devenv';
    asuAPI = 'https://asu.insticator.devenv';
    rmsAPI = 'https://rms.insticator.devenv';
    spmAPI = 'https://spm.insticator.devenv';
    mockupAPI = 'https://mockup.insticator.devenv';
    newAdminPanel = 'http://admin.insticator.devenv';
    break;

  case 'REVIEW':
    staticAPI = 'https://static.instireviews.com';
    embedDistribution = 'https://d3915abhigtdy.cloudfront.net';
    headerCodeDistribution = 'ds9xcqcwv6rb0.cloudfront.net';
    siteURL = 'instireviews';
    baseURL = 'instireviews.com';
    caAPI = 'https://ca.instireviews.com';
    cmsAPI = 'https://cms.instireviews.com';
    commenting = 'https://staging.soapps.net/test';
    ccuAPI = 'https://ccu.instireviews.com';
    ratingAPI = 'https://rating.instireviews.com';
    embedAPI = 'https://dashboard.instireviews.com';
    ppaAPI = 'https://ppa.instireviews.com';
    asuAPI = 'https://asu.instireviews.com';
    rmsAPI = 'https://rms.instireviews.com';
    spmAPI = 'https://spm.instireviews.com';
    mockupAPI = 'https://mockup.instireviews.com';
    newAdminPanel = 'http://admin.instireviews.com';
    break;

  case 'STAGING': // fall through

  default:
    staticAPI = 'https://static.hunchme.com';
    embedDistribution = 'https://dchetohgcb1b1.cloudfront.net';
    headerCodeDistribution = 'd2uyq6p4qku0nd.cloudfront.net';
    siteURL = 'hunchme';
    baseURL = 'hunchme.com';
    caAPI = 'https://ca.hunchme.com';
    cmsAPI = 'https://cms.hunchme.com';
    commenting = 'https://staging.soapps.net/test';
    ccuAPI = 'https://ccu.hunchme.com';
    ratingAPI = 'https://rating.hunchme.com';
    embedAPI = 'https://dashboard.hunchme.com';
    ppaAPI = 'https://ppa.hunchme.com';
    asuAPI = 'https://asu.hunchme.com';
    rmsAPI = 'https://rms.hunchme.com';
    spmAPI = 'https://spm.hunchme.com';
    mockupAPI = 'https://mockup.hunchme.com';
    newAdminPanel = 'http://admin.hunchme.com';
} // store URLs for export


var url = {
  baseURL: baseURL,
  company: "https://www.".concat(siteURL, ".com"),
  static: {
    url: staticAPI,
    files: {
      url: "".concat(staticAPI, "/files"),
      images: "".concat(staticAPI, "/files/images")
    }
  },
  embedv4: "".concat(embedDistribution, "/embed-core/embed_core.js"),
  headerCode: {
    url: "".concat(headerCodeDistribution),
    adsCode: "//".concat(headerCodeDistribution, "/ads-code")
  },
  social: {
    facebook: "https://www.facebook.com/insticator",
    twitter: "https://twitter.com/Insticator_inc",
    linkedin: "https://www.linkedin.com/company/insticator"
  },
  ca: {
    url: caAPI,
    category: "".concat(caAPI, "/v1/category")
  },
  cms: {
    url: cmsAPI,
    classification: {
      url: "".concat(cmsAPI, "/v1/classification"),
      questions: "".concat(cmsAPI, "/v1/classification/questions"),
      setQuestionsLiveForDmp: "".concat(cmsAPI, "/v1/classification/set-questions-live-for-dmp"),
      updateQuestion: "".concat(cmsAPI, "/v1/classification/update-question")
    }
  },
  commenting: {
    base: commenting,
    integrations: "".concat(commenting, "/integrations")
  },
  ccu: {
    base: ccuAPI,
    commentingUnits: "".concat(ccuAPI, "/v1/commenting-units"),
    addOns: "".concat(ccuAPI, "/v1/commenting-units/add-ons")
  },
  rating: {
    url: ratingAPI,
    ratingUnits: "".concat(ratingAPI, "/v1/rating-units")
  },
  embed: {
    url: embedAPI,
    admin: {
      url: "".concat(embedAPI, "/admin"),
      extendSession: "".concat(embedAPI, "/admin/extendsession"),
      loggedIn: "".concat(embedAPI, "/admin/logged-in"),
      permission: "".concat(embedAPI, "/admin/permission")
    },
    adNetwork: "".concat(embedAPI, "/adnetwork"),
    dashboardMessage: "".concat(embedAPI, "/dashboardmessage"),
    geoBlocking: "".concat(embedAPI, "/geoblocking"),
    sites: {
      url: "".concat(embedAPI, "/sites"),
      publisherPortal: "".concat(embedAPI, "/sites/publisher-portal")
    },
    utils: "".concat(embedAPI, "/utils")
  },
  newAdminPanel: {
    base: newAdminPanel
  },
  asu: {
    url: asuAPI,
    pubPortal: {
      sites: "".concat(asuAPI, "/pub-portal/v1/sites"),
      articleSentimentUnits: "".concat(asuAPI, "/pub-portal/v1/article-sentiment-units")
    },
    articleSentimentUnits: "".concat(asuAPI, "/v1/article-sentiment-units")
  },
  ppa: {
    url: ppaAPI,
    accounts: "".concat(ppaAPI, "/v1/accounts"),
    agreements: "".concat(ppaAPI, "/v1/agreements"),
    auth: {
      url: "".concat(ppaAPI, "/v1/auth"),
      extendSession: "".concat(ppaAPI, "/v1/auth/extend-session"),
      google: "".concat(ppaAPI, "/v1/auth/google"),
      login: "".concat(ppaAPI, "/v1/auth/login"),
      logout: "".concat(ppaAPI, "/v1/auth/logout"),
      password: "".concat(ppaAPI, "/v1/auth/password"),
      profile: "".concat(ppaAPI, "/v1/auth/profile"),
      resend: "".concat(ppaAPI, "/v1/auth/resend"),
      resetPassword: "".concat(ppaAPI, "/v1/auth/reset-password"),
      token: "".concat(ppaAPI, "/v1/auth/token"),
      unmock: "".concat(ppaAPI, "/v1/auth/unmock"),
      activateUser: "".concat(ppaAPI, "/v1/auth/activate-user")
    },
    embeds: "".concat(ppaAPI, "/v1/embeds"),
    emojis: "".concat(ppaAPI, "/v1/emojis"),
    users: "".concat(ppaAPI, "/v1/users"),
    leads: "".concat(ppaAPI, "/v1/leads"),
    metrics: {
      url: "".concat(ppaAPI, "/v1/metrics"),
      questionAnswered: "".concat(ppaAPI, "/v1/metrics/question-answered"),
      embedLoad: "".concat(ppaAPI, "/v1/metrics/embed-load"),
      uniqueEngagedUsers: "".concat(ppaAPI, "/v1/metrics/unique-engaged-users"),
      storyClicked: "".concat(ppaAPI, "/v1/metrics/story-clicked"),
      revenue: "".concat(ppaAPI, "/v1/metrics/revenue")
    },
    paymentInfo: "".concat(ppaAPI, "/v1/paymentinfo"),
    report: "".concat(ppaAPI, "/v1/report"),
    sites: "".concat(ppaAPI, "/v1/sites")
  },
  rms: {
    url: rmsAPI,
    clientReport: "".concat(rmsAPI, "/v1/clientreport"),
    metrics: {
      url: "".concat(rmsAPI, "/v1/metrics"),
      revenue: "".concat(rmsAPI, "/v1/metrics/revenue")
    },
    rpm: {
      revenue: "".concat(rmsAPI, "/v1/rpm/revenue")
    }
  },
  spm: {
    url: "".concat(spmAPI, "/v1/")
  },
  mockup: {
    url: "".concat(mockupAPI, "/v1/")
  }
};
exports.url = url;
var sharedURLs = url;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

exports.sharedURLs = sharedURLs;